import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DateService, DateUnit } from "@services/date.service";
import { TranslationService } from "@services/translation.service";
import { IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import './zone-summary-view.component.scss';

@Component({
    selector: 'zone-summary-view',
    template: require('./zone-summary-view.component.html')
})
export class ZoneSummaryViewComponent implements OnInit {
    @Input() zone: IZoneWithProbes;
    @Input() clickable: boolean;

    @Output() zoneSelected = new EventEmitter<number>();

    setpointLastUpdated: string;
    latestTimes: Date[] = []
    dateRangeStart: Date;
    zoneInactive: boolean;
    zoneActiveAgo: string;
    // ---

    constructor(
        private readonly dateService: DateService,
        private readonly translationService: TranslationService) {
        this.dateRangeStart = this.dateService.addOrSubtractTime(new Date, -1, DateUnit.Day)
    }

    ngOnInit() {
        this.getZoneLastUpdated();

    }

    selectZone(id: number) {
        this.zoneSelected.emit(id);
    }

    getSetpointLastUpdated(): void {

        if (this.zone?.setpoint?.histories.length) {
            const formattedDate = this.dateService.formatDate(this.zone.setpoint.histories[0].StartTime, { dateTime: true });
            this.latestTimes.push(this.zone.setpoint.histories[0].StartTime);
            this.setpointLastUpdated = `${this.translationService.t("Common.LastUpdated")} ${formattedDate}`;
        }
        else {
            this.setpointLastUpdated = this.translationService.t("ZoneSummaryView.UnknownDate");
        }
    }

    getZoneLastUpdated() {
        this.getSetpointLastUpdated();

        if (this.zone.zoneOperatingMode && this.zone.zoneOperatingMode.latestRecord) {
            this.latestTimes.push(this.zone.zoneOperatingMode.latestRecord.EventTime)
        }

        this.zone.probes.forEach(probe => {
            if (probe.latestRecord) {
                this.latestTimes.push(probe.latestRecord.Timestamp)
            }
        });

        var latestZoneUpdate = this.dateService.getLatestDate(this.latestTimes);
        this.zoneInactive = !this.dateService.date1IsAfterDate2(latestZoneUpdate, this.dateRangeStart);
        this.zoneActiveAgo = this.dateService.relativeTime(latestZoneUpdate);
    }

    // ---
}
